<template>
  <div class="item-tile" :style="`background-image: url(${photo});`">
    <h5 class="item-tile-heading" v-if="heading && !input">
      {{ heading }}
    </h5>
    <Input
      class="input"
      :heading="heading"
      v-if="input"
      :type="inputType"
      @scs-input="textInput"
      :initialValue="initialInputValue"
    />
    <p v-if="text" class="item-tile-text">
      {{ text }}
    </p>

    <div class="item-tile-round-button-container">
      <round-button-with-icon
        v-if="selected !== undefined"
        :icon="processing ? 'spinner' : selected ? 'x' : 'plus'"
        class="item-tile-round-button-with-icon"
        @click="primaryIconClicked"
      />

      <round-button-with-icon
        v-for="(icon, index) in secondaryIcons"
        :key="index"
        :icon="icon"
        @click="secondaryIconClicked(icon)"
        class="item-tile-round-button-with-icon"
      />
    </div>
  </div>
</template>
<script>
import RoundButtonWithIcon from "./RoundButtonWithIcon.vue";

import Input from "../Elements/Input.vue";
export default {
  data() {
    return {
      timer: undefined,
    };
  },
  methods: {
    primaryIconClicked() {
      this.$emit("primary-icon-clicked");
    },
    secondaryIconClicked(icon) {
      this.$emit("secondary-icon-clicked", icon);
    },
    textInput(value) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => {
        this.$emit("input", value);
      }, 800);
    },
  },
  components: {
    RoundButtonWithIcon,
    Input,
  },
  emits: ["primary-icon-clicked", "secondary-icon-clicked", "input"],
  props: [
    "selected",
    "secondaryIcon",
    "secondaryIcons",
    "text",
    "heading",
    "input",
    "inputType",
    "inputPlaceholder",
    "initialInputValue",
    "photo",
    "slotDisplay",
    "processing",
  ],
};
</script>
<style scoped>
.item-tile {
  width: 120px;
  min-width: 120px;
  height: 120px;
  min-height: 120px;
  margin: 10px;

  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  border-radius: 15px;
  filter: drop-shadow(0px 4px 3px var(--secondaryColor));
  background-color: var(--backgroundColor);
  background-size: cover;
  cursor: pointer;
}

.item-tile:before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.75);
  z-index: 0;
}

.item-tile > * {
  z-index: 2;
}

.input {
  width: 75px;
  margin-bottom: 15px;
}

p {
  width: 95%;
  padding: 5px;
  box-sizing: border-box;
  margin: 5px;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 16px;
  text-align: right;
}

h5 {
  margin: 7px;
  text-align: left;
}

.item-tile-round-button-container {
  position: absolute;
  right: -8px;
  top: -8px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  z-index: 3;
}

.item-tile-round-button-with-icon {
  margin: 0 0 5px 0;
  background-color: var(--backgroundColor);
  filter: drop-shadow(0 2px 2px var(--shadow));
}
.item-tile-round-button-with-icon:hover {
  filter: drop-shadow(0 2px 2px var(--shadow));
}
</style>
